import { makeStyles } from "@material-ui/core/styles";

import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

export const useStyles = makeStyles(() => ({
  progressWrapper: {
    position: "relative",
  },
  progressTrack: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  progressLabel: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
  },
}));

interface Props {
  value: number;
  size: string;
  thickness: number;
}

const CircularProgressWithLabel: React.FC<Props> = ({ value, size, thickness }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.progressWrapper}
      style={{ width: size, height: size }}
      role="progressbar"
      aria-valuenow={value}
      aria-label="Progress percentage"
    >
      <CircularProgress
        variant="static"
        value={100}
        thickness={thickness}
        className={classes.progressTrack}
        style={{ width: "100%", height: "100%", color: "#e0e0e0" }}
      />
      <CircularProgress
        variant="static"
        value={value}
        thickness={thickness}
        color="secondary"
        style={{
          width: "100%",
          height: "100%",
        }}
      />
      <Box className={classes.progressLabel}>
        <Typography variant="caption" style={{ fontSize: `calc(${size} * 0.3)` }}>
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
